import { EmailServices } from '../enums/emailServices.enum';
import { IconName } from '../enums/IconName.enum';

export interface IMailButton {
    text: EmailServices;
    icon: IconName;
    link: string;
}
